var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "images-loaded",
          rawName: "v-images-loaded",
          value: _vm.layout,
          expression: "layout",
        },
      ],
      staticClass: "row card-holder-embedded gy-4",
    },
    [
      _vm._t("content", function () {
        return [_vm._v("\n    ...\n  ")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }